/* eslint-disable no-case-declarations */
import { KFTextInput } from "@kf/ic2fx";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Chip, Divider, Link, Skeleton, Typography } from "@mui/material";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getPeerGroupsFiltersThunk } from "store/slices/peerGroupsSlice";
import styled from "styled-components";
import SearchJobPricing from "../../../components/JobPricing/Search";
import { JobPricingCategory } from "../../../constants/JobPricingReportConstants";
import { PAGE_URL } from "../../../constants/urls.constants";
import { getLanguageCode } from "../../../utilities/helper";
import { isParticipatePackage } from "../../../services/ReportsService";
import { JobPricingReportViewBy } from "../../../helpers/models/JobPricingDetailModels";
import { RootState } from "../../../store/reducers";
import {
  configThunk,
  resetConfigState
} from "../../../store/slices/configSlice";
import { CountryListThunk } from "../../../store/slices/countryDetailsSlice";
import { initPayloadMappings } from "../../../store/slices/filtersSlice";
import {
  getPricingFiltersThunk,
  updateReportHeaderDetails
} from "../../../store/slices/jobPricingDetailsSlice";
import { SJPRListTypes } from "../../../store/slices/jobPricingListSlice";
import { updateJobPricingPayloads } from "../../../store/slices/jobPricingSearchSlice";
import { setSearchItemClicked } from "../../../store/slices/jobPricingSlice";
import {
  getFilters,
  JobPricingListThunk,
  resetFilters,
  resetFiltersCount,
  resetJobPricingList,
  resetPeerGroupId,
  resetSearchKey,
  updatedSearchKey,
  updateFilters,
  updateJobCatogery,
  updatePeerGroupId,
  updateSelectedPeerGroup
} from "../../../store/slices/SJPR/listSlice";
import { arrayEquals } from "../../../utilities/array.utils";
import { ChipsWithDropdown, ChipsWithMultiDropdown } from "./chip-dropdown";
import styles from "./index.module.scss";
import { JobFamilyDropdown } from "./jobFamilyDropdown";
interface IconfigPayload {
  countryCode: string | null;
  language: string;
  year: number;
}

const CustomTextInput = styled(KFTextInput)(({ theme }) => ({
  "& .MuiTextField-root": {
    borderRadius: "20px"
  }
}));
const jobDetailApPayload: any = {
  jobfamily: "marketJobFamily",
  jobsubfamily: "marketJobSubFamily",
  industry: "marketIndustry",
  region: "marketRegion",
  clientownership: "marketOwnershipType",
  numofemp: "marketEmployeeCount",
  revenuerangedesc: "marketRevenueRange",
  grade: "gradeId",
  incumbent: "marketClass"
};
export const FILTER_PAYLOAD_KEY: any = {
  jobfamily: "jobfamily",
  jobsubfamily: "jobsubfamily"
};

const Header: React.FC = () => {

  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const [selectedFilters, setSlectedFilters] = useState<any>({});
  const [payloadKeysState, setPlayloadKeysState] = useState<any>();
  const [itemsTodisplay, setItemsToDisplay] = useState<any>({
    showItemsCount: 3,
    expanded: false
  });
  const [selectedOptionsChip, setSelectedOptionsChip] = useState<any>();
  const [value, setValue] = useState("");
  const [isFilterChange, setIsFilterChange] = useState<boolean>(false);
  const [_selectedOptionsChipsArr, _setSelectedOptionsChipsArr] = useState<any>(
    []
  );
  const [isConfigLoading, setIsConfigLoading] = useState(false);
  const { headerDetails, reportViewBy } = useSelector(
    (state: RootState) => state.jobPricingDetails
  );
  const { jobPricingPayloads } = useSelector(
    (state: RootState) => state.jobPricingSearch
  );
  const { jobPricingList } = useSelector((state: RootState) => {
    return state;
  });
  const { isSearchItemClicked } = useSelector(
    (state: RootState) => state.jobpricing
  );
  const { selectedCountry } = useSelector((state: RootState) => state.country);
  const { selectedCurrency } = useSelector(
    (state: RootState) => state.currency
  );
  const [showFilterTagsCount, setShowFilterTagsCount] = useState<any>({});
  const currentURL = location.pathname;
  const { user, country } = useSelector((state: any) => state);
  const { peerGroups, isPeerGroupsLoading, peerGroupsError } = useSelector(
    (state: RootState) => state.peerGroups
  );
  const { configList, allYearsConfigList } = useSelector(
    (state: RootState) => state.config
  );
  const [allYearsConfigListState, setAllYearsConfigListState] = useState<any>(
    []
  );

  const { selectedPeerGroup: storedPeerGroup } = useSelector(
    (state: RootState) => state.jobPricingList
  );
  const { isSJPR } = useSelector((state: RootState) => state.country);

  // Hide the peer group dropdown for basic (2,16) and participate (17,50) packages.
  const isPackageWithoutPeerGroup = useMemo(() => {
    const currentCountryDetails =
      country?.countryListAPIData?.countryList?.find(
        (eachCountry: any) => eachCountry.countryCode === selectedCountry?.key
      );
    const result = !!(
      currentCountryDetails &&
      isParticipatePackage(currentCountryDetails?.productBrandId)
    );
    return result;
  }, [country?.countryListAPIData, selectedCountry?.key]);

  const [selectedPeerGroup, setSelectedPeerGroup] = useState<any>(storedPeerGroup || null);
  const [pendingPeerGroup, setPendingPeerGroup] = useState<any>(storedPeerGroup || null);

  useEffect(() => {
    if (storedPeerGroup?.key) {
      dispatch(updatePeerGroupId(Number(storedPeerGroup.key)));
    }
  }, []);

  let mappedPeerGroups: Array<{ key: string; label: string }> = [];
  const mapPeerGroupsToKeyLabel = (peerGroupsArray: any[]) => {
    if (!peerGroupsArray) return [];
    return peerGroupsArray.map((peerGroup) => ({
      key:
        peerGroup.peergroupid === null || peerGroup.peergroupid === undefined
          ? ""
          : String(peerGroup.peergroupid),
      label: peerGroup.peergroupname || ""
    }));
  };
  if (peerGroups?.data?.data?.peerGroups) {
    mappedPeerGroups = mapPeerGroupsToKeyLabel(
      peerGroups.data.data.peerGroups || []
    );
  }

  const hasDataInActiveTable = (): boolean => {
    const { list, category } = jobPricingList;

    switch (category) {
      case SJPRListTypes.JOBS:
        return (list?.jobs?.length > 0) || (list?.tabCount?.jobNameCount > 0);
      case SJPRListTypes.FUNCTION:
        return (list?.functions?.length > 0) || (list?.tabCount?.jobFamilyCount > 0);
      case SJPRListTypes.GRADES:
        return (list?.grades?.length > 0) || (list?.tabCount?.gradeCount > 0);
      default:
        return (list?.jobs?.length > 0) || (list?.tabCount?.jobNameCount > 0);
    }
  };

  const getFilterTagsCountLabel = () => {
    if (
      Object.keys(showFilterTagsCount).length === 0 &&
      jobPricingList?.filtersList &&
      Object.keys(jobPricingList?.filtersList).length > 0
    ) {
      const filterTagsLabel: any = {};
      for (const filterLabel in jobPricingList.filtersList) {
        filterTagsLabel[filterLabel] = 3;
      }
      setShowFilterTagsCount(filterTagsLabel);
    }
  };
  const updateFilterTagsCountLabel = (filterName: string) => {
    setShowFilterTagsCount({
      ...showFilterTagsCount,
      [filterName]:
        showFilterTagsCount[filterName] > 3
          ? 3
          : selectedOptionsChip[filterName].length
    });
  };
  const clearAllGroupFilters = (filterName: string) => {
    delete selectedOptionsChip[filterName];
    let allNewFilters: any = {
      ...payloadKeysState,
      [filterName]: []
    };
    if (
      filterName == FILTER_PAYLOAD_KEY.jobsubfamily ||
      filterName == FILTER_PAYLOAD_KEY.jobfamily
    ) {
      allNewFilters[FILTER_PAYLOAD_KEY.jobsubfamily] = [];
      allNewFilters[FILTER_PAYLOAD_KEY.jobfamily] = [];
      delete selectedFilters[FILTER_PAYLOAD_KEY.jobfamily];
      delete selectedFilters[FILTER_PAYLOAD_KEY.jobsubfamily];
      delete selectedOptionsChip[FILTER_PAYLOAD_KEY.jobfamily];
      delete selectedOptionsChip[FILTER_PAYLOAD_KEY.jobsubfamily];
      setSelectedJobFamilies({
        familyList: [],
        subFamilyList: []
      });
    }
    setSelectedOptionsChip({
      ...selectedOptionsChip
    });
    setPlayloadKeysState(allNewFilters);
    delete selectedFilters[filterName];
    setSlectedFilters({
      ...selectedFilters
    });
    setIsFilterChange(true);
  };
  const showMoreClick = () => {
    itemsTodisplay.showItemsCount === 3
      ? setItemsToDisplay({
        showItemsCount: selectedOptionsChip.length,
        expanded: true
      })
      : setItemsToDisplay({ showItemsCount: 3, expanded: false });
  };
  const updateDisplaySelectedFilters = () => {
    if (
      jobPricingList?.filtersList &&
      Object.keys(jobPricingList?.filtersList)?.length > 0 &&
      selectedOptionsChip &&
      Object.keys(selectedOptionsChip).length > 0
    ) {
      for (let filterName in selectedOptionsChip) {
        const filterListAPI = jobPricingList.filtersList[filterName] || [];
        if (filterListAPI && filterListAPI.length > 0) {
          const filterList = selectedOptionsChip[filterName].filter(
            (element: any, index: number) =>
              filterListAPI.some(
                (item: any, index: number) => element.key === item.key
              )
          );
          selectedOptionsChip[filterName] = filterList;
          payloadKeysState[filterName] = filterList.map(
            (item: any, index: number) => item.key
          );
        }
        //  else {
        //   delete selectedOptionsChip[filterName];
        //   payloadKeysState[filterName] = [];
        // }
      }
      setSelectedOptionsChip({
        ...selectedOptionsChip
      });
      setPlayloadKeysState({
        ...payloadKeysState
      });
      dispatch(updateFilters(payloadKeysState));
    }
  };
  const manageFilterSelection = (
    action: string,
    option?: any,
    filterKey?: any
  ) => {
    switch (action) {
      case "CLEAR_ALL":
        setPlayloadKeysState({});
        setSelectedOptionsChip({});
        setSlectedFilters({});
        // setIsFilterChange(true);
        setSelectedJobFamilies({
          familyList: [],
          subFamilyList: []
        });
        // dispatch(resetFiltersCount());
        setPendingPeerGroup(null);
        setSelectedPeerGroup(null);
        dispatch(resetPeerGroupId());
        dispatch(resetFilters());
        break;
      case "CLEAR":
        if (
          filterKey == FILTER_PAYLOAD_KEY.jobsubfamily ||
          filterKey == FILTER_PAYLOAD_KEY.jobfamily
        ) {
          //chip = filterKey
          const chipIndex = selectedOptionsChip[filterKey]?.findIndex(
            (ele: any) => ele.key == option?.key
          );
          if (chipIndex > -1) {
            const isAllOptionThere = selectedFilters[filterKey]?.filter(
              (_fil: any) => _fil?.key === "ALL"
            );
            let newFiltersSubFunction: any = [];
            let newFiltersFunction: any = [];
            const currentselectedFilters: any = { ...selectedFilters };
            if (currentselectedFilters[filterKey]?.length === 1) {
              newFiltersSubFunction = [];
              newFiltersFunction = [];
              setSlectedFilters({
                ...selectedFilters,
                [FILTER_PAYLOAD_KEY.jobfamily]: [],
                [FILTER_PAYLOAD_KEY.jobsubfamily]: []
              });
            } else {
              newFiltersSubFunction = selectedFilters[filterKey]?.filter(
                (_item: any) => _item.key !== option?.key && _item.key !== "ALL"
              );
              setSlectedFilters({
                ...selectedFilters,
                [filterKey]: newFiltersSubFunction
              });
            }
            let filteredOptionsData = selectedOptionsChip[filterKey]?.filter(
              (_item: any) => _item.key !== option?.key
            );
            let updatedSelectedOptionsChip = {
              ...selectedOptionsChip,
              [filterKey]: filteredOptionsData
            };
            if (filteredOptionsData?.length == 0) {
              delete updatedSelectedOptionsChip[FILTER_PAYLOAD_KEY.jobfamily];
              delete updatedSelectedOptionsChip[
                FILTER_PAYLOAD_KEY.jobsubfamily
              ];
            }
            for (let filterOption in updatedSelectedOptionsChip) {
              if (
                !updatedSelectedOptionsChip[filterOption] ||
                updatedSelectedOptionsChip[filterOption].length === 0
              ) {
                delete updatedSelectedOptionsChip[filterOption];
              }
            }
            // setSelectedOptionsChip(updatedSelectedOptionsChip);
            const filteredDataIs = payloadKeysState[filterKey]?.filter(
              (ky: any) => ky != option?.key
            );
            const payloadKey = {
              ...payloadKeysState,
              [filterKey]: filteredDataIs
            };
            if (
              (filterKey == FILTER_PAYLOAD_KEY.jobfamily ||
                filterKey == FILTER_PAYLOAD_KEY.jobsubfamily) &&
              filteredDataIs?.length == 0
            ) {
              payloadKey[FILTER_PAYLOAD_KEY.jobsubfamily] = [];
              payloadKey[FILTER_PAYLOAD_KEY.jobfamily] = [];
              setSelectedJobFamilies({ familyList: [], subFamilyList: [] });
            }
            // if (filterKey == FILTER_PAYLOAD_KEY.jobsubfamily) {
            //   let mainIndex: any = { f: -1, sf: -1 };
            //   currentselectedFilters[FILTER_PAYLOAD_KEY.jobfamily].findIndex(
            //     (ele: any, index: any) => {
            //       ele?.jobsubfamily.map((subEle: any, subIndex: any) => {
            //         if (subEle?.key == option?.key) {
            //           mainIndex = { f: index, sf: subIndex };
            //         }
            //       });
            //     }
            //   );
            //   if (mainIndex?.f > -1) {
            //     currentselectedFilters[FILTER_PAYLOAD_KEY.jobfamily][mainIndex?.f].splice(
            //       mainIndex.sf,
            //       1
            //     );
            //     if (currentselectedFilters[FILTER_PAYLOAD_KEY.jobfamily]?.length < 1) {
            //       currentselectedFilters[FILTER_PAYLOAD_KEY.jobfamily] = [];
            //     }
            //   }
            // }
            let selectedOptionsChipLocal: any = { ...selectedOptionsChip };
            if (filterKey == FILTER_PAYLOAD_KEY.jobsubfamily) {
              let mainIndex: any = { f: -1, sf: -1 };
              selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily].map(
                (ele: any, index: any) => {
                  ele?.jobsubfamily.map((subEle: any, subIndex: any) => {
                    if (subEle?.key == option?.key) {
                      mainIndex = { f: index, sf: subIndex };
                      selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily][
                        index
                      ]?.jobsubfamily.splice(subIndex, 1);
                      if (
                        selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily][
                          index
                        ]?.jobsubfamily?.length == 0
                      ) {
                        selectedOptionsChipLocal[
                          FILTER_PAYLOAD_KEY.jobfamily
                        ].splice(index, 1);
                      }
                    }
                  });
                }
              );
              selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobsubfamily].map(
                (ele: any, index: any) => {
                  if (
                    ele?.key == option?.key &&
                    selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobsubfamily] &&
                    selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobsubfamily][
                    index
                    ]
                  ) {
                    selectedOptionsChipLocal[
                      FILTER_PAYLOAD_KEY.jobsubfamily
                    ].splice(index, 1);
                  }
                }
              );
            } else {
              let findex: any = -1;
              selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily].map(
                (ele: any, index: any) => {
                  if (ele?.key == option?.key) {
                    findex = index;
                    ele?.jobsubfamily?.map((sf: any) => {
                      const indexOfSF = selectedOptionsChipLocal[
                        FILTER_PAYLOAD_KEY.jobsubfamily
                      ]?.findIndex((jsf: any) => jsf?.key == sf?.key);
                      if (indexOfSF > -1) {
                        selectedOptionsChipLocal[
                          FILTER_PAYLOAD_KEY.jobsubfamily
                        ]?.splice(indexOfSF, 1);
                      }
                    });
                    // selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobsubfamily].splice(index, 1);
                  }
                }
              );
              selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily].splice(
                findex,
                1
              );
            }
            // let updatedSelectedOptionsChip = {
            //   ...selectedOptionsChip,
            //   [filterKey]: selectedOptionsChip[filterKey]?.filter(
            //     (_item: any) => _item.key !== option?.key
            //   )
            // };
            if (
              (filterKey == FILTER_PAYLOAD_KEY.jobfamily ||
                filterKey == FILTER_PAYLOAD_KEY.jobsubfamily) &&
              filteredDataIs?.length == 0
            ) {
              delete selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily];
              delete selectedOptionsChipLocal[FILTER_PAYLOAD_KEY.jobfamily];
            }
            for (let filterOption in selectedOptionsChipLocal) {
              if (
                !selectedOptionsChipLocal[filterOption] ||
                selectedOptionsChipLocal[filterOption].length === 0
              ) {
                delete selectedOptionsChipLocal[filterOption];
                if (
                  filterOption == FILTER_PAYLOAD_KEY.jobfamily &&
                  filteredDataIs?.length == 0
                ) {
                  delete selectedOptionsChipLocal[
                    FILTER_PAYLOAD_KEY.jobsubfamily
                  ];
                }
              }
            }
            setSelectedOptionsChip(selectedOptionsChipLocal);
            setPlayloadKeysState(payloadKey);
          }
        } else {
          for (let chip in selectedOptionsChip) {
            selectedOptionsChip[chip]?.map((item: any) => {
              if (item.key === option?.key) {
                const isAllOptionThere = selectedFilters[chip]?.filter(
                  (_fil: any) => _fil?.key === "ALL"
                );
                if (selectedFilters[chip]?.length === 1) {
                  setSlectedFilters({
                    ...selectedFilters,
                    [chip]: []
                  });
                } else {
                  setSlectedFilters({
                    ...selectedFilters,
                    [chip]: selectedFilters[chip]?.filter(
                      (_item: any) =>
                        _item.key !== option?.key && _item.key !== "ALL"
                    )
                  });
                }
                let updatedSelectedOptionsChip = {
                  ...selectedOptionsChip,
                  [chip]: selectedOptionsChip[chip]?.filter(
                    (_item: any) => _item.key !== option?.key
                  )
                };
                for (let filterOption in updatedSelectedOptionsChip) {
                  if (
                    !updatedSelectedOptionsChip[filterOption] ||
                    updatedSelectedOptionsChip[filterOption].length === 0
                  ) {
                    delete updatedSelectedOptionsChip[filterOption];
                  }
                }
                setSelectedOptionsChip(updatedSelectedOptionsChip);
                setPlayloadKeysState({
                  ...payloadKeysState,
                  [chip]: payloadKeysState[chip]?.filter(
                    (filterKey: any) => filterKey !== option?.key
                  )
                });
                const getCount = () => {
                  if (selectedOptionsChip[chip].length === 1) {
                    return 0;
                  } else if (isAllOptionThere.length > 0) {
                    return selectedFilters[chip]?.length - 2;
                  } else {
                    return selectedFilters[chip]?.length - 1;
                  }
                };
                // this will updated count on change
                // dispatch(
                //   updateFiltersCount({
                //     [chip]: getCount()
                //   })
                // );
                // return;
              } else {
                // return;
              }
            });
          }
        }
        // return true;
        break;
      default:
        break;
    }
    setTimeout(() => {
      setIsFilterChange(true);
    }, 500);
  };
  const onMultiSelectChangeComp = (
    filter: any,
    option: any,
    action?: string
  ) => {
    if (option?.type === "RESTORE") {
      setSlectedFilters({
        ...selectedFilters,
        ...option.values
      });
      return;
    }
    if (option === "CLEAR_ALL") {
      let _clearAllObj: any = {};
      let _clearAllCountObj: any = {};
      Object.keys(filter)?.map((_filName: string) => {
        _clearAllObj[_filName] = [];
        _clearAllCountObj[_filName] = 0;
      });
      setSlectedFilters({
        ...selectedFilters,
        ..._clearAllObj
      });
      // this will updated count on change
      // dispatch(updateFiltersCount(_clearAllCountObj));
      return;
    }
    const selectedFilter = selectedFilters[filter] || [];
    if (option?.key === "ALL") {
      if (filter === 'grade') {
        const gradeOptions = jobPricingList?.filtersList?.[filter] || [];
        if (gradeOptions.length > 3) {
          return;
        }
      }
      let _selectedFilter = [...selectedFilter];
      const _isAllOptionThere = _selectedFilter.filter(
        (_opt: any) => _opt.key === option?.key
      );
      if (_isAllOptionThere.length > 0) {
        setSlectedFilters({
          ...selectedFilters,
          [filter]: []
        });
        // this will updated count on change
        // dispatch(updateFiltersCount({ [filter]: 0 }));
      } else {
        let filterItems = jobPricingList?.filtersList[filter] || [];
        filterItems.map((item: any) => {
          let isItemThere: any = _selectedFilter?.filter(
            (_item: any) => _item.key === item?.key
          );
          if (isItemThere?.length === 0) {
            _selectedFilter.push(item);
          }
          return;
        });
        _selectedFilter.push({
          key: "ALL",
          label: t("pa.selectAll")
        });
        setSlectedFilters({
          ...selectedFilters,
          [filter]: _selectedFilter
        });
        // this will updated count on change
        // dispatch(updateFiltersCount({ [filter]: _selectedFilter.length - 1 }));
      }
      return;
    } else {
      if (selectedFilter.length > 0) {
        let isItemThere: any = selectedFilter?.filter(
          (_item: any) => _item.key === option?.key
        );
        if (isItemThere?.length > 0) {
          let updatedselectedFilter = selectedFilter?.filter(
            (_item: any) => _item.key !== option.key && _item.key !== "ALL"
          );
          if (selectedFilter?.length === 1) {
            setSlectedFilters({
              ...selectedFilters,
              [filter]: []
            });
          } else {
            setSlectedFilters({
              ...selectedFilters,
              [filter]: updatedselectedFilter
            });
          }
          // this will updated count on change
          // dispatch(
          //   updateFiltersCount({ [filter]: updatedselectedFilter.length })
          // );
        } else {
          if (
            selectedFilters[filter]?.length + 1 ==
            jobPricingList?.filtersList[filter]?.length
          ) {
            setSlectedFilters({
              ...selectedFilters,
              [filter]: [
                ...selectedFilter,
                option,
                {
                  key: "ALL",
                  label: t("pa.selectAll")
                }
              ]
            });
          } else {
            setSlectedFilters({
              ...selectedFilters,
              [filter]: [...selectedFilter, option]
            });
          }
          // this will updated count on change
          // dispatch(updateFiltersCount({ [filter]: selectedFilter.length + 1 }));
        }
      } else {
        setSlectedFilters({
          ...selectedFilters,
          [filter]: [option]
        });
        // this will updated count on change
        // dispatch(updateFiltersCount({ [filter]: 1 }));
      }
    }
  };
  const onMultiSelectChange = (filter: any, option: any, action?: string) => {
    if (option?.type === "RESTORE") {
      setSlectedFilters({
        ...selectedFilters,
        [filter]: option.values
      });
      return;
    }
    const selectedFilter = selectedFilters[filter] || [];
    if (option === "CLEAR_ALL") {
      setSlectedFilters({
        ...selectedFilters,
        [filter]: []
      });
      // this will updated count on change
      // dispatch(updateFiltersCount({ [filter]: 0 }));
      return;
    }
    if (option?.key === "ALL") {
      let _selectedFilter = [...selectedFilter];
      const _isAllOptionThere = _selectedFilter.filter(
        (_opt: any) => _opt.key === option?.key
      );
      if (_isAllOptionThere.length > 0) {
        setSlectedFilters({
          ...selectedFilters,
          [filter]: []
        });
        // this will updated count on change
        // dispatch(updateFiltersCount({ [filter]: 0 }));
        return;
      } else {
        jobPricingList?.filtersList[filter].map((item: any) => {
          let isItemThere: any = _selectedFilter?.filter(
            (_item: any) => _item.key === item?.key
          );
          if (isItemThere?.length === 0) {
            _selectedFilter.push(item);
          }
          return;
        });
        _selectedFilter.push({
          key: "ALL",
          label: t("pa.selectAll")
        });
        setSlectedFilters({
          ...selectedFilters,
          [filter]: _selectedFilter
        });
        // this will updated count on change
        // dispatch(updateFiltersCount({ [filter]: _selectedFilter.length - 1 }));
        return;
      }
    } else {
      if (selectedFilter.length > 0) {
        let isItemThere: any = selectedFilter?.filter(
          (_item: any) => _item.key === option?.key
        );
        if (isItemThere?.length > 0) {
          setSlectedFilters({
            ...selectedFilters,
            [filter]: selectedFilter?.filter(
              (item: any) => item.key !== option.key && item.key !== "ALL"
            )
          });
          // this will updated count on change
          // dispatch(updateFiltersCount({ [filter]: selectedFilter.length - 1 }));
          return;
        } else {
          if (filter === 'grade' && selectedFilter.length >= 3) {
            return;
          }
          if (
            selectedFilters[filter]?.length + 1 ==
            jobPricingList?.filtersList[filter]?.length
          ) {
            setSlectedFilters({
              ...selectedFilters,
              [filter]: [
                ...selectedFilter,
                option,
                {
                  key: "ALL",
                  label: t("pa.selectAll")
                }
              ]
            });
            return;
          } else {
            setSlectedFilters({
              ...selectedFilters,
              [filter]: [...selectedFilter, option]
            });
            // this will updated count on change
            // dispatch(
            //   updateFiltersCount({ [filter]: selectedFilter.length + 1 })
            // );
            return;
          }
        }
        return;
      } else {
        setSlectedFilters({
          ...selectedFilters,
          [filter]: [option]
        });
        // this will updated count on change
        // dispatch(updateFiltersCount({ [filter]: 1 }));
      }
    }
  };
  const onMultiSelectClose = (event: any, reason: string, filterName: any) => {
    if (typeof filterName === "string") {
      let selectedFilter = selectedFilters[filterName] || [];
      let updatedSelectedOptionsChip = {
        ...selectedOptionsChip
      };
      let updatedSelectedFilters = {
        ...selectedFilters
      };
      let updatedPayloadKeysState = { ...payloadKeysState };
      if (reason == "CLEAR_ALL") {
        delete updatedSelectedFilters[filterName];
        delete updatedSelectedOptionsChip[filterName];
        delete updatedPayloadKeysState[filterName];
      } else {
        if (selectedFilter?.length) {
          selectedFilter = selectedFilter.filter(
            (_opt: any) => _opt.key !== "ALL"
          );
          updatedSelectedOptionsChip[filterName] = selectedFilter;
          let selectedOptions: any = [];
          selectedFilter?.map((_filter: any) => {
            selectedOptions.push(_filter.key);
          });
          updatedPayloadKeysState[filterName] = selectedOptions;
        } else {
          delete updatedSelectedOptionsChip[filterName];
          delete updatedPayloadKeysState[filterName];
        }
      }
      setSelectedOptionsChip(updatedSelectedOptionsChip);
      setSlectedFilters(updatedSelectedFilters);
      setPlayloadKeysState(updatedPayloadKeysState);
      setIsFilterChange(true);
      return;
    } else {
      const prevSubfamilyChis = selectedOptionsChip?.jobsubfamily;
      if (filterName?.length > 0) {
        let updatedSelectedOptionsChip = {
          ...selectedOptionsChip
        };
        let updatedSelectedFilters = {
          ...selectedFilters
        };
        let updatedPayloadKeysState = { ...payloadKeysState };
        filterName?.map((filter: any, index: any) => {
          let selectedFilter = selectedFilters[filter] || [];
          if (reason == "CLEAR_ALL") {
            delete updatedSelectedFilters[filter];
            delete updatedSelectedOptionsChip[filter];
            delete updatedPayloadKeysState[filter];
          } else {
            if (selectedFilter?.length) {
              selectedFilter = selectedFilter.filter(
                (_opt: any) => _opt.key !== "ALL"
              );
              updatedSelectedOptionsChip[filter] = selectedFilter;
              let selectedOptions: any = [];
              selectedFilter?.map((_filter: any) => {
                selectedOptions.push(_filter.key);
                return _filter;
              });
              updatedPayloadKeysState[filter] = selectedOptions;
            } else {
              delete updatedSelectedOptionsChip[filter];
              delete updatedPayloadKeysState[filter];
            }
            return filter;
          }
        });
        if (prevSubfamilyChis) {
          updatedSelectedOptionsChip.jobsubfamily = prevSubfamilyChis;
        }
        setSelectedOptionsChip(updatedSelectedOptionsChip);
        setSlectedFilters(updatedSelectedFilters);
        updatedPayloadKeysState.jobsubfamily =
          updatedSelectedFilters?.jobsubfamily;
        setPlayloadKeysState(updatedPayloadKeysState);
        setIsFilterChange(true);
      }
    }
  };
  const getTabList = (
    searchKey?: string,
    category?: string,
    peerGroupValue?: any
  ) => {
    dispatch(resetJobPricingList());
    let updatedFilterPayload: any = { ...jobPricingList?.filters };
    for (const key in updatedFilterPayload) {
      if (updatedFilterPayload[key]?.length === 0) {
        delete updatedFilterPayload[key];
      }
    }
    let updatedPayloadKeysState = { ...payloadKeysState };
    for (const key in updatedPayloadKeysState) {
      if (updatedPayloadKeysState[key]?.length === 0) {
        delete updatedPayloadKeysState[key];
      }
    }
    const peerGroupToUse =
      peerGroupValue !== undefined ? peerGroupValue : pendingPeerGroup;
    const peerGroupId = peerGroupToUse?.key
      ? Number(peerGroupToUse.key)
      : undefined;

    if (updatedPayloadKeysState?.["peer-groups"]) {
      delete updatedPayloadKeysState["peer-groups"];
    }

    let data: any;
    if ((searchKey && searchKey?.length > 0) || value.length > 0) {
      data = {
        search: searchKey || value || "",
        countryCode: selectedCountry?.key,
        language: getLanguageCode()
      };
    } else {
      data = {
        countryCode: selectedCountry?.key,
        language: getLanguageCode()
      };
    }

    if (peerGroupId) {
      data.peerGroupId = peerGroupId;
    }

    data.filters = updatedPayloadKeysState || updatedFilterPayload || " ";
    const payLoad = {
      category: category || jobPricingList?.category || SJPRListTypes?.JOBS,
      data
    };
    !headerDetails?.title && dispatch(JobPricingListThunk(payLoad));
  };
  const updatePricingFilters = (searchKey?: any, peerGroupValue?: any) => {
    let updatedFilterPayload: any = { ...jobPricingList?.filters };
    for (const key in updatedFilterPayload) {
      if (updatedFilterPayload[key]?.length === 0) {
        delete updatedFilterPayload[key];
      }
    }
    let updatedPayloadKeysState = { ...payloadKeysState };
    for (const key in updatedPayloadKeysState) {
      if (updatedPayloadKeysState[key]?.length === 0) {
        delete updatedPayloadKeysState[key];
      }
    }

    const peerGroupToUse =
      peerGroupValue !== undefined ? peerGroupValue : pendingPeerGroup;
    const peerGroupId = peerGroupToUse?.key
      ? Number(peerGroupToUse.key)
      : undefined;

    if (updatedPayloadKeysState?.["peer-groups"]) {
      delete updatedPayloadKeysState["peer-groups"];
    }

    let data: any = {};
    if (currentURL && currentURL === PAGE_URL.JOB_PRICING_DETAILS) {
      data = {
        filters: {
          ...(updatedPayloadKeysState || updatedFilterPayload || {})
        },
        language: getLanguageCode(),
        countryCode: selectedCountry?.key
      };
      if (peerGroupId) {
        data.peerGroupId = peerGroupId;
      }

      if (reportViewBy === JobPricingReportViewBy.JOB) {
        data.selectedJobOrgCode = jobPricingPayloads.jobOrgCode;
      } else if (reportViewBy === JobPricingReportViewBy.FUNCTION) {
        data.selectedJobfamilyKey = jobPricingPayloads.marketJobFamily;
        data.filters.grade = jobPricingPayloads.gradeId.split(",");
      } else if (reportViewBy === JobPricingReportViewBy.GRADE) {
        data.selectedGradeId = jobPricingPayloads.gradeId;
      }
    } else {
      if ((searchKey && searchKey?.length > 0) || value?.length > 0) {
        data = {
          filters: updatedPayloadKeysState || {},
          language: getLanguageCode(),
          countryCode: selectedCountry?.key,
          search: searchKey || value || ""
        };
      } else {
        data = {
          filters: updatedPayloadKeysState || {},
          language: getLanguageCode(),
          countryCode: selectedCountry?.key
        };
      }
      if (peerGroupId) {
        data.peerGroupId = peerGroupId;
      }
    }
    dispatch(getPricingFiltersThunk(data));
  };
  const applyPeerGroupSelection = (peerGroup: any) => {
    const nextPeerGroup = peerGroup?.key ? peerGroup : null;
    setPendingPeerGroup(nextPeerGroup);
    setSelectedPeerGroup(nextPeerGroup);
    if (nextPeerGroup?.key) {
      dispatch(updatePeerGroupId(Number(nextPeerGroup.key)));
      dispatch(updateSelectedPeerGroup(nextPeerGroup));
    } else {
      dispatch(resetPeerGroupId());
      dispatch(updateSelectedPeerGroup(null));
    }
    dispatch(resetJobPricingList());
    dispatch(updateJobPricingPayloads({
      peerGroupKey: (nextPeerGroup?.key || "ALL").toString()
    }));
    if (currentURL !== PAGE_URL.JOB_PRICING_DETAILS) {
      getTabList(undefined, undefined, nextPeerGroup);
    }
    updatePricingFilters(undefined, nextPeerGroup);
  };
  const handleSearch = (e: any) => {
    if (e.key === "Enter" && (value.length >= 3 || value.length === 0) &&
      value !== (jobPricingList?.searchKey || "")) {
      sessionStorage.removeItem("searchKey");
      dispatch(resetJobPricingList());
      dispatch(updatedSearchKey(value));
      if (!headerDetails?.title) {
        //  switching to grades tab when search for grade
        if (
          value?.toLocaleLowerCase().includes(t("pa.sjpr.searchKey.grade")) &&
          jobPricingList?.category != JobPricingCategory.GRADE
        ) {
          sessionStorage.setItem("searchKey", JSON.stringify(value));
          dispatch(updateJobCatogery(JobPricingCategory.GRADE));
          dispatch(updatedSearchKey(value));
          return;
        }
        updatePricingFilters(value);
        getTabList(value);
      }
    }
  };
  const getFilterLabel = (filterkey: string): string => {
    const filterswithLabel: any = {
      jobfamily: "pa.functionTitle",
      jobsubfamily: "pa.subFunction",
      industry: "pa.industryTitle",
      incumbent: "pa.incumbentsClass",
      region: "pa.regionTitle",
      clientownership: "pa.ownership",
      numofemp: "pa.employeeCountTitle",
      revenuerangedesc: "pa.revenueRangeTitle",
      grade: "pa.grade"
    };
    return filterswithLabel[filterkey]
      ? (t(filterswithLabel[filterkey]) as string)
      : "";
  };

  const getOptionsWithAll = (filter: any) => {
    let options = [...jobPricingList?.filtersList[filter]];
    if (options.length > 1) {
      let allOption = {
        key: "ALL",
        label: t("pa.selectAll")
      };
      options.unshift(allOption);
    }
    return options;
  };
  const getJobFamilyOptons = (options: any) => {
    let jobFamilyOptions: any = [];
    options?.map((opt: any) => {
      opt?.jobsubfamily?.length > 0 ? jobFamilyOptions.push(opt) : null;
    });
    return jobFamilyOptions;
  };
  // ++++++++++++++++++++++++++++++++++++++
  const [selectedJobFamilies, setSelectedJobFamilies]: any = useState({
    familyList: [],
    subFamilyList: []
  });
  const [familyData, setFamilyData]: any = useState({
    familyList: [],
    subFamilyList: []
  });
  const onJobFunctionSubFunctionChange = (
    familyList: any,
    subFamilyList: any,
    apiData: any,
    selectedData: any
  ) => {
    if (familyList?.length == 0 || subFamilyList?.length == 0) {
      setSlectedFilters((prev: any) => {
        return {
          ...prev,
          jobfamily: [],
          jobsubfamily: []
        };
      });
      setIsFilterChange(true);
      setPlayloadKeysState({
        ...payloadKeysState,
        jobfamily: [],
        jobsubfamily: []
      });
      const prevChips = selectedOptionsChip ? selectedOptionsChip : {};
      setTimeout(() => {
        delete prevChips.jobfamily;
        delete prevChips.jobsubfamily;
        setSelectedJobFamilies({
          familyList: [],
          subFamilyList: []
        });
        setSelectedOptionsChip({
          ...prevChips
        });
      }, 350);
      dispatch(resetJobPricingList());
      return;
    }
    setFamilyData(apiData);
    const familyKeys = apiData?.familyList.map((ele: any) => {
      return ele.key;
    });
    const subFamilyKeys = apiData?.subFamilyList.map((ele: any) => {
      return ele.key;
    });
    const isJobFamilySame = arrayEquals(
      familyKeys,
      payloadKeysState?.jobfamily || []
    );
    const isJobSubFamilySame = arrayEquals(
      subFamilyKeys,
      payloadKeysState?.jobsubfamily || []
    );
    setSelectedJobFamilies({
      familyList: selectedData?.familyList,
      subFamilyList: selectedData?.subFamilyList
    });
    if (!isJobFamilySame || !isJobSubFamilySame) {
      setSlectedFilters((prev: any) => {
        return {
          ...prev,
          jobfamily: familyKeys,
          jobsubfamily: subFamilyKeys
        };
      });
      setIsFilterChange(true);
      setPlayloadKeysState({
        ...payloadKeysState,
        jobfamily: familyKeys,
        jobsubfamily: subFamilyKeys
      });
      // updatePricingFilters();
      const prevChips = selectedOptionsChip ? selectedOptionsChip : [];
      setTimeout(() => {
        setSelectedOptionsChip({
          ...prevChips,
          jobfamily: familyList,
          jobsubfamily: subFamilyList
        });
      }, 350); //since reset was on other place
    }
  };
  const onJobfamilySelectChange = (filter: any, option: any) => {
    const selectedFilter = selectedFilters[filter] || [];
    // if (!action) setIsMultiSelectedFilters(true);
    if (option === "CLEAR_ALL") {
      setSlectedFilters({
        ...selectedFilters,
        [filter]: []
      });
      return;
    }
    if (option?.key === "ALL") {
      let _selectedFilter = [...selectedFilter];
      const _isAllOptionThere = _selectedFilter.filter(
        (_opt: any) => _opt.key === option?.key
      );
      if (_isAllOptionThere.length > 0) {
        setSlectedFilters({
          ...selectedFilters,
          [filter]: []
        });
        return;
      } else {
        jobPricingList?.filtersList[filter].map((item: any) => {
          _selectedFilter.push(item);
        });
        _selectedFilter.push({
          key: "ALL",
          label: t("pa.selectAll")
        });
        setSlectedFilters({
          ...selectedFilters,
          [filter]: _selectedFilter
        });
        return;
      }
    }
    if (selectedFilter.length > 0) {
      selectedFilter?.filter((_fOption: any) => {
        if (option.key === _fOption.key) {
          setSlectedFilters({
            ...selectedFilters,
            [filter]: selectedFilter.filter(
              (item: any) => item.key !== option.key
            )
          });
          return;
        } else {
          setSlectedFilters({
            ...selectedFilters,
            [filter]: [...selectedFilter, option]
          });
          return;
        }
      });
    } else {
      setSlectedFilters({
        [filter]: [option]
      });
    }
  };

  const isGradesSequential = (grades: string[]) => {
    for (let i = 1; i < grades.length; i++) {
      if (Number(grades[i]) !== Number(grades[i - 1]) + 1) {
        return false;
      }
    }
    return true;
  };

  const getDisplayGradeSpan = (gradeList: string[]) => {
    const sorted = [...gradeList].sort(
      (a: any, b: any) => a.match(/\d+/) - b.match(/\d+/)
    );
    if (sorted.length > 1 && isGradesSequential(sorted)) {
      return sorted[0] + " - " + sorted[sorted.length - 1];
    } else {
      return sorted.join(", ");
    }
  };

  const initConfig = (year?: number) => {
    setIsConfigLoading(true);
    const updatedYear = year
      ? year
      : (configList[0]?.marketYear ?? new Date().getFullYear());
    const payload: IconfigPayload = {
      countryCode: selectedCountry?.key ?? null,
      language: "en",
      year: updatedYear
    };
    dispatch(configThunk(payload));
  };
  useEffect(() => {
    if (country?.countryList?.length < 1) {
      dispatch(CountryListThunk(""));
    }
    if (!configList || configList.length === 0) {
      initConfig();
    }
    dispatch(initPayloadMappings());
  }, []);

  const fetchPeerGroups = async () => {
    const config = { ...configList[0] };
    try {
      const response = await dispatch(
        getPeerGroupsFiltersThunk({
          mktDefinitionKey: config?.marketDefinitionKey,
          countryCode: selectedCountry?.key
        })
      );
    } catch (error) {
      console.error("Error fetching peer groups:", error);
    }
  };
  useEffect(() => {
    if (configList?.length > 0 && configList[0]?.marketDefinitionKey) {
      fetchPeerGroups();
    }
  }, [configList]);

  useEffect(() => {
    if (!headerDetails?.title && isFilterChange && payloadKeysState) {
      getTabList();
      dispatch(getFilters());
    }
    if (
      currentURL &&
      currentURL === PAGE_URL.JOB_PRICING_DETAILS &&
      payloadKeysState &&
      isFilterChange
    ) {
      let JobPricingPayloads: any = {};
      let jobDetailsAPIPayloadKeys = { ...jobDetailApPayload };
      let selectedFiltersState = { ...payloadKeysState };
      if (reportViewBy === JobPricingReportViewBy.JOB) {
        delete jobDetailsAPIPayloadKeys.jobfamily;
        delete jobDetailsAPIPayloadKeys.jobsubfamily;
        // delete jobDetailsAPIPayloadKeys.grade;
        let gradeIdList: string[] = [];
        if (payloadKeysState?.grade && payloadKeysState?.grade.length > 0) {
          gradeIdList = payloadKeysState.grade;
          selectedFiltersState.grade = gradeIdList;
          const pricingHeaderDetails = {
            ...headerDetails,
            grade: getDisplayGradeSpan(gradeIdList)
          };
          dispatch(updateReportHeaderDetails(pricingHeaderDetails));
        } else {

          delete jobDetailsAPIPayloadKeys.grade;
        }

      } else if (reportViewBy === JobPricingReportViewBy.FUNCTION) {
        delete jobDetailsAPIPayloadKeys.jobfamily;
        let gradeIdList = [];
        if (payloadKeysState?.grade && payloadKeysState?.grade.length > 0) {
          gradeIdList = payloadKeysState.grade;
        } else {
          if (
            jobPricingList?.filtersList &&
            jobPricingList?.filtersList.grade &&
            jobPricingList?.filtersList.grade.length > 0
          ) {
            gradeIdList = jobPricingList.filtersList.grade.map(
              (data: any) => data.key || ""
            );
            selectedFiltersState.grade = gradeIdList;
          }
        }
        const pricingHeaderDetails = {
          ...headerDetails,
          gradeSpan: getDisplayGradeSpan(gradeIdList)
        };
        dispatch(updateReportHeaderDetails(pricingHeaderDetails));
      } else if (reportViewBy === JobPricingReportViewBy.GRADE) {
        delete jobDetailsAPIPayloadKeys.grade;
      }
      for (let payLoadKey in jobDetailsAPIPayloadKeys) {
        JobPricingPayloads[jobDetailsAPIPayloadKeys[payLoadKey]] =
          selectedFiltersState[payLoadKey]?.toString(",") || "ALL";
      }
      dispatch(updateJobPricingPayloads(JobPricingPayloads));
      dispatch(updateFilters(payloadKeysState));
      updatePricingFilters();
      setIsFilterChange(false);
    }
    if (
      currentURL &&
      currentURL === PAGE_URL.JOB_PRICING_LIST &&
      payloadKeysState &&
      isFilterChange
    ) {
      dispatch(updateFilters(payloadKeysState));
      updatePricingFilters();
      setIsFilterChange(false);
    }
  }, [payloadKeysState, isFilterChange]);
  useEffect(() => {
    if (
      isSearchItemClicked &&
      currentURL &&
      currentURL === PAGE_URL.JOB_PRICING_DETAILS
    ) {
      updatePricingFilters();
      dispatch(setSearchItemClicked(false));
    }
  }, [isSearchItemClicked]);
  useEffect(() => {
    dispatch(resetFiltersCount());
    return () => {
      dispatch(resetFilters());
      dispatch(resetPeerGroupId());
    };
  }, []);
  useEffect(() => {
    jobPricingList?.searchKey && setValue(jobPricingList?.searchKey);
  }, [jobPricingList?.searchKey]);
  /* useEffect(() => {
    dispatch(updatedSearchKey(value));
  }, [value]); */
  useEffect(() => {
    let selectedOptions: any = [];
    selectedOptionsChip &&
      (Object.values(selectedOptionsChip)?.length > 0
        ? Object.values(selectedOptionsChip)?.map((item: any) => {
          item?.map((_item: any) => {
            selectedOptions.push(_item);
          });
        })
        : _setSelectedOptionsChipsArr([]));
    _setSelectedOptionsChipsArr(selectedOptions);
  }, [selectedOptionsChip]);
  useEffect(() => {
    // if (
    //   !jobPricingList?.isFiltersloading &&
    //   jobPricingList?.filtersList &&
    //   Object.keys(jobPricingList?.filtersList)?.length === 0
    // ) {
    //   setSlectedFilters({});
    //   setSelectedOptionsChip({});
    //   setPlayloadKeysState({});
    // }
    // setSlectedFilters(selectedFilters);
    // setSelectedOptionsChip(selectedOptionsChip);
    // setPlayloadKeysState(payloadKeysState);
    // updateDisplaySelectedFilters();
    // getFilterTagsCountLabel();
    if (
      jobPricingList?.filtersList &&
      Object.keys(jobPricingList?.filtersList)?.length > 0
    ) {
      updateDisplaySelectedFilters();
      getFilterTagsCountLabel();
    } else if (jobPricingList?.isApiFailed) {
      setSlectedFilters({});
      setSelectedOptionsChip({});
      setPlayloadKeysState({});
    }
  }, [jobPricingList?.filtersList]);
  const renderHelperText = (value: any) => {
    if (value?.match(/(\d+)/)?.length > 0 && value.length <= 2) {
      return t("pa.sjpr.search.NumericValidation");
    }
    if (value && value?.length < 3) {
      return t("pa.sjpr.search.searchHelperText");
    }
    return "";
  };

  const getMoreFilters = () => {
    if (!jobPricingList?.filtersList) return {};

    const moreFilters = Object.fromEntries(
      Object.entries(jobPricingList?.filtersList)
        .slice(4)
        ?.filter((ele: any) => ele[0] !== FILTER_PAYLOAD_KEY.jobsubfamily)
    );
    return moreFilters;
  };

  return (
    <div className={styles.headerContainer}>
      <div className={styles.filtersSection}>
        {headerDetails?.title ? (
          <SearchJobPricing />
        ) : (
          <CustomTextInput
            variant="standard"
            label=""
            autoComplete="off"
            className={styles.headerTextField}
            placeholder={t("pa.sjpr.ListsearchPlaceholder")}
            value={value}
            onChange={(e) => {
              sessionStorage.removeItem("searchKey");
              // dispatch(resetSearchKey());
              setValue(e.target.value);
              // if (e.target.value?.length === 0) {
              // getTabList("");
              // updatePricingFilters("");
              // }
            }}
            onKeyDown={(e) => handleSearch(e)}
            disabled={
              jobPricingList?.isFiltersloading || jobPricingList?.isListloading
            }
          />
        )}

        {jobPricingList?.isFiltersloading
          ? [1, 2, 3, 4].map((value: number, index: number) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={500}
              height={35}
              sx={{ borderRadius: 30 }}
            />
          ))
          : jobPricingList?.filtersList && (
            <div className={styles.filtersContainer}>
              {" "}
              {isPeerGroupsLoading ? (
                <Skeleton
                  variant="rectangular"
                  width={125}
                  height={35}
                  sx={{ borderRadius: 30 }}
                />
              ) : !isPackageWithoutPeerGroup &&
                (hasDataInActiveTable() ||
                  currentURL === PAGE_URL.JOB_PRICING_DETAILS) && (
                <ChipsWithDropdown
                  key={"peer-groups"}
                  name={"peer-groups"}
                  label={t("pa.peergroupstitle")}
                  options={mappedPeerGroups}
                  values={selectedPeerGroup ? [selectedPeerGroup] : []}
                  singleSelect
                  headerLinkText={ isSJPR ? t("pa.createpeergroup") : ""}
                  headerLinkUrl={ isSJPR ? PAGE_URL.CREATE_PEER_GROUP + "/" + selectedCountry?.key : ""}
                  onChipChange={(option: any) => {
                    if (option?.type === "RESTORE") {
                      return;
                    }
                    applyPeerGroupSelection(option);
                  }}
                  onClose={() => undefined}
                />
              )}
              {Object.entries(jobPricingList?.filtersList)
                .slice(0, 4)
                .map((filterItem: any) => {
                  // if (filterItem[0] === FILTER_PAYLOAD_KEY.jobsubfamily) {
                  //   return <></>;
                  // }
                  if (filterItem[0] === FILTER_PAYLOAD_KEY.jobfamily) {
                    return (
                      <JobFamilyDropdown
                        key={filterItem[0]}
                        name={filterItem[0]}
                        label={getFilterLabel(filterItem[0])}
                        options={getJobFamilyOptons(
                          getOptionsWithAll(filterItem[0])
                        )}
                        selectedValues={selectedJobFamilies}
                        onJobfamilyChipChange={(
                          option: any,
                          subOption: any,
                          apiData: any,
                          selectedData: any
                        ) => {
                          onJobFunctionSubFunctionChange(
                            option,
                            subOption,
                            apiData,
                            selectedData
                          );
                        }}
                      />
                    );
                  }
                  return (
                    <ChipsWithDropdown
                      key={filterItem[0]}
                      name={filterItem[0]}
                      label={getFilterLabel(filterItem[0])}
                      options={getOptionsWithAll(filterItem[0])}
                      values={selectedFilters[filterItem[0]] || {}}
                      onChipChange={(option: any, action: string) => {
                        onMultiSelectChange(filterItem[0], option, action);
                      }}
                      onClose={(event: any, reason: string) => {
                        onMultiSelectClose(event, reason, filterItem[0]);
                      }}
                    />
                  );
                })}
              <ChipsWithMultiDropdown
                filters={getMoreFilters()}
                values={selectedFilters || {}}
                onChipMultiChange={(option: any, filter: any) => {
                  onMultiSelectChangeComp(filter, option);
                }}
                onClose={(event: any, reason: string) => {
                  dispatch(resetJobPricingList());
                  onMultiSelectClose(
                    event,
                    reason,
                    Object.keys(jobPricingList?.filtersList).slice(4)
                  );
                }}
              />
            </div>
          )}
        <div className={styles.countryTextContainer}>
          <span className={styles.countryText}>
            {selectedCountry?.label}{" "}
            {selectedCountry?.label
              ? selectedCurrency
                ? `(${selectedCurrency})`
                : ""
              : ""}
          </span>
        </div>
      </div>
      {(selectedPeerGroup ||
        (selectedOptionsChip &&
          Object.keys(selectedOptionsChip).length > 0)) && (
          <Box className={styles.selectedFiltersContainer}>
            {selectedPeerGroup && (
              <>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    marginRight: 1,
                    marginBottom: 1
                  }}
                >
                  Peer Groups:
                </Typography>
                <Chip
                  key={`chip-peer-group-${selectedPeerGroup.key}`}
                  label={selectedPeerGroup.label}
                  sx={{
                    marginRight: 1,
                    marginBottom: 1,
                    backgroundColor: "#FFFFFF",
                    color: "#243D42",
                    borderRadius: "18px"
                  }}
                  deleteIcon={
                    <CloseIcon
                      sx={{
                        "&.MuiChip-deleteIcon": {
                          color: "#243D42",
                          fontSize: "18px"
                        }
                      }}
                    />
                  }
                  onDelete={() => {
                    applyPeerGroupSelection(null);
                  }}
                />

                {selectedOptionsChip &&
                  Object.keys(selectedOptionsChip).length > 0 && (
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      sx={{
                        margin: "2px 0.75rem 10px",
                        borderWidth: "1px",
                        borderColor: "#ABABAB"
                      }}
                    />
                  )}
              </>
            )}
            {selectedOptionsChip &&
              Object.keys(selectedOptionsChip).map(
                (filterKey: string, index: number) => (
                  <Fragment key={index}>
                    {selectedOptionsChip[filterKey] &&
                      selectedOptionsChip[filterKey].length > 0 && (
                        <>
                          {index > 0 && (
                            <Divider
                              orientation="vertical"
                              variant="middle"
                              flexItem
                              sx={{
                                margin: "2px 0.75rem 10px",
                                borderWidth: "1px",
                                borderColor: "#ABABAB"
                              }}
                            />
                          )}
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              marginRight: 1,
                              marginBottom: 1
                            }}
                          >
                            {getFilterLabel(filterKey)}:
                          </Typography>
                          {selectedOptionsChip[filterKey]
                            .slice(0, showFilterTagsCount[filterKey])
                            .map((_chip: any, index: number) => (
                              <Chip
                                key={`chip-${_chip?.label}-${_chip?.key}-${index}`}
                                label={_chip?.label}
                                sx={{
                                  marginRight: 1,
                                  marginBottom: 1,
                                  backgroundColor: "#FFFFFF",
                                  color: "#243D42",
                                  borderRadius: "18px"
                                }}
                                deleteIcon={
                                  <CloseIcon
                                    sx={{
                                      "&.MuiChip-deleteIcon": {
                                        color: "#243D42",
                                        fontSize: "18px"
                                      }
                                    }}
                                  />
                                }
                                onDelete={() => {
                                  dispatch(resetJobPricingList());
                                  manageFilterSelection(
                                    "CLEAR",
                                    _chip,
                                    filterKey
                                  );
                                }}
                              />
                            ))}
                          {selectedOptionsChip[filterKey].length > 3 && (
                            <Link
                              underline="always"
                              variant="body2"
                              className={styles.viewMore}
                              onClick={() => {
                                updateFilterTagsCountLabel(filterKey);
                              }}
                            >
                              {showFilterTagsCount[filterKey] > 3
                                ? "View less"
                                : `+${selectedOptionsChip[filterKey].length - 3
                                } More`}
                            </Link>
                          )}
                          {selectedOptionsChip[filterKey].length > 1 && (
                            <Link
                              underline="always"
                              variant="body2"
                              className={styles.clearAllFilters}
                              onClick={() => {
                                clearAllGroupFilters(filterKey);
                              }}
                            >
                              Clear all
                            </Link>
                          )}
                        </>
                      )}
                  </Fragment>
                )
              )}
            {selectedOptionsChip &&
              (Object.keys(selectedOptionsChip).length > 1 ||
                (Object.keys(selectedOptionsChip).length >= 1 &&
                  selectedPeerGroup)) && (
                <>
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    sx={{
                      margin: "2px 0.75rem 10px",
                      borderWidth: "1px",
                      borderColor: "#ABABAB"
                    }}
                  />
                  <Link
                    underline="always"
                    variant="body2"
                    className={styles.clearAllFilters}
                    onClick={() => {
                      manageFilterSelection("CLEAR_ALL");
                      setSelectedPeerGroup(null);
                      setIsFilterChange(true);
                    }}
                  >
                    {t("pa.clearAllFilters")}
                  </Link>
                </>
              )}
          </Box>
        )}
      {/* {_selectedOptionsChipsArr && _selectedOptionsChipsArr.length > 0 && (
        <div className={styles.selectedFiltersBlock}>
          <Box className="selected-chips-wrapper">
            {_selectedOptionsChipsArr
              ?.slice(0, itemsTodisplay.showItemsCount)
              ?.map((_chip: any, index: any) => {
                return (
                  <Chip
                    key={`chip-${_chip?.label}-${_chip?.key}-${index}`}
                    label={_chip?.label}
                    style={{ marginBottom: 8 }}
                    deleteIcon={<CloseIcon />}
                    onDelete={() => {
                      dispatch(resetJobPricingList());
                      manageFilterSelection("CLEAR", _chip);
                      setIsFilterChange(true);
                    }}
                  />
                );
              })}
            <span className={styles.viewMore}>
              {_selectedOptionsChipsArr?.length > 3 && (
                <>
                  <a
                    onClick={() => {
                      showMoreClick();
                    }}
                  >
                    {itemsTodisplay.expanded ? (
                      <span>View less</span>
                    ) : (
                      <span>+{_selectedOptionsChipsArr.length - 3} More</span>
                    )}
                  </a>
                  |{" "}
                </>
              )}
              {_selectedOptionsChipsArr.length > 1 && (
                <a
                  onClick={() => {
                    manageFilterSelection("CLEAR_ALL");
                    setItemsToDisplay({
                      showItemsCount: 3,
                      expanded: false
                    });
                    setIsFilterChange(true);
                  }}
                >
                  Clear all filters
                </a>
              )}
            </span>
          </Box>
        </div>
      )} */}
    </div>
  );
};
export default Header;
